<script>
import Navbar from "@/components/navigation/Navbar.vue";
import Sidebar from "@/components/navigation/Sidebar.vue";
import Footer from "@/components/navigation/Footer.vue";

export default {
  components: {Footer, Navbar, Sidebar},

}
</script>

<template>
  <div id="smart-layout">
    <!--NAVBAR-->
    <Navbar :show-logo="!$store.getters.isAuthenticated"/>
    <!--SIDEBAR-->
    <Sidebar v-if="$store.getters.isAuthenticated"/>
    <!--MAIN CONTENT-->
    <v-main
      style="margin-bottom:40px;padding-bottom:0;"
      :style="$store.getters.isSidebarExpanded ? 'margin-left: 56px' : 'margin-left: 0px'">
      <router-view/>
    </v-main>
    <!--FOOTER-->
    <Footer v-if="!$store.getters.isAuthenticated"/>
  </div>
</template>

<style lang="scss">
@import '@/styles/variables.scss';
//@import '@/styles/fonts.scss';
@import '@/styles/main.scss';
@import '@/styles/scrollbar.scss';
@import '@/styles/inputs.scss';

header {
  max-height: 64px;
}

.no-indent {
  padding-left: 0 !important;
}

.child-item {
  background: rgba(250, 250, 250, 0.95);
}

.child-item-indent {
  padding-left: 32px;
}

.v-list-group__items {
  margin-left: 0 !important;
}
</style>
